export default __webpack_public_path__ + "static/media/airdockz-bpk-banner-1.faee60c5.jpg";